import {Base} from '../../common/model/base.model';
import {Helpers} from '../../common/helpers/helpers';

export class Indirizzo extends Base {

  constructor(protected id: number,
              public via: string,
              public civico: string,
              public localita: string,
              public comune: string,
              public provincia: string,
              public siglaProvincia: string,
              public nazione: string,
              public cap: string,
              public geoId: number,
  ) {
    super(id);
  }

  public static getLabelComune(comune, provincia): string {
    if (!comune) {
      return '';
    }
    let label = comune;
    label = Helpers.capitalizeName(label);
    if (!provincia) {
      return label;
    }
    label = label + Indirizzo.provinciaLabel(comune, provincia);
    return label;
  }

  public static provinciaLabel(comune, provincia): string {
    if (!provincia) {
      return '';
    }
    if (comune.toLowerCase() === provincia.toLowerCase()) {
      return '';
    }
    return ' (' + Helpers.capitalizeWord(provincia) + ')';
  }

  public getId() {
    return this.geoId;
  }

  public getLabelComune() {
    return Indirizzo.getLabelComune(this.comune, this.siglaProvincia);
  }

  public getLabel() {
    let label = this.via;
    if (this.civico) {
      label = label + ' ' + this.civico;
    }
    // if (this.comune) {
    //   label = label + ' ' + this.comune;
    // }
    label = Helpers.capitalizeName(label);
    label = label + Indirizzo.getLabelComune(this.comune, this.siglaProvincia);
    return label;
  }



}

